module.exports = __webpack_public_path__ + "static/media/menu_icon_01.f94f8d18.svg";